import React from "react";
import DynamicBreadcrumb from "../../components/DynamicBreadcrumb";
import SustainabilityBanner from "./SustainabilityBanner";
import SustainApproch from "./SustainApproach";
import SustainDiscuss from "./SustainDiscuss";
import AboutDocs from "../about/AboutDocs";

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Sustainability",
  },
];

const bannerData = {
  img:"assets/images/sustainabiity-banner-bg.webp",
  leftHead:"Sustainability",
  rightHead:"Our Responsibility in a Changing World",
  desc:"At Dox and Box, sustainability is not just an initiative—it is a core part of how we operate and grow. As a modern Eco-Friendly records and information management company, we recognize our responsibility toward our clients, communities, the environment across every region we serve."
}
export default function Sustainability(){
  return(
    <>
    <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
    <SustainabilityBanner data={bannerData} />
    <SustainApproch/>
    <SustainDiscuss/>
    <div className="sustain-docs">
      <AboutDocs/>
    </div>
    </>
  )
}